import { render, staticRenderFns } from "./copyrightDetails.vue?vue&type=template&id=947eee9a&scoped=true&"
import script from "./copyrightDetails.vue?vue&type=script&lang=js&"
export * from "./copyrightDetails.vue?vue&type=script&lang=js&"
import style0 from "./copyrightDetails.vue?vue&type=style&index=0&id=947eee9a&prod&lang=less&"
import style1 from "./copyrightDetails.vue?vue&type=style&index=1&id=947eee9a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947eee9a",
  null
  
)

export default component.exports